module.exports = __webpack_public_path__ + "img/panneau-publicitaire-ok.15c542b6.jpg";